module.exports = __webpack_public_path__ + "static/media/Black logo - no background.0a02bfa1.svg";